import { render, staticRenderFns } from "./OrderOverviewView.vue?vue&type=template&id=5bb85de4&scoped=true"
import script from "./OrderOverviewView.vue?vue&type=script&lang=js"
export * from "./OrderOverviewView.vue?vue&type=script&lang=js"
import style0 from "./OrderOverviewView.vue?vue&type=style&index=0&id=5bb85de4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb85de4",
  null
  
)

export default component.exports